var _style, _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreProcessing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Machine Learning - Feature learning by Sasha is Sasha. Public Domain. 2017") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "sashaissasha.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 71.1,
    cy: 69.4,
    r: 17.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.8,43.7c9.5,0,17.1-7.7,17.1-17.1S80.2,9.5,70.8,9.5s-17.1,7.7-17.1,17.1S61.3,43.7,70.8,43.7z M70.8,15.9 c5.9,0,10.7,4.8,10.7,10.7c0,5.9-4.8,10.7-10.7,10.7s-10.7-4.8-10.7-10.7C60.1,20.7,64.9,15.9,70.8,15.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 28.5,
    cy: 26.6,
    r: 17.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 28.3,
    cy: 69.4,
    r: 17.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreProcessing);
export default __webpack_public_path__ + "static/media/pre_processing.fb3f4511129e5b035617788093204bab.svg";
export { ForwardRef as ReactComponent };